import { render, staticRenderFns } from "./EventDetailLayout.vue?vue&type=template&id=2a28d9aa"
import script from "./EventDetailLayout.vue?vue&type=script&lang=js"
export * from "./EventDetailLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports